export default __webpack_public_path__ + "static/media/gallery-13.06082eab.jpg";